module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/vi-card-drag.0c35beb1605ed98a3140.gif";